import {  t  } from "@/client/libs/dummy-i18n";
import { 
  ArrowLeftIcon, 
  HouseSimpleIcon, 
  SidebarSimpleIcon 
} from "@phosphor-icons/react";
import { Button } from "@stackmorph/ui";
import { motion } from "framer-motion";
import { Link } from "react-router";

import { useBuilderStore } from "@/client/stores/builder";
import { useResumeStore } from "@/client/stores/resume";

export const BuilderHeader = () => {
  const title = useResumeStore((state) => state.resume.title);
  const toggle = useBuilderStore((state) => state.toggle);

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="z-[50] h-16 w-full border-b border-white/10 bg-background/60 backdrop-blur-xl supports-[backdrop-filter]:bg-background/40"
    >
      <div className="flex h-full items-center justify-between px-4">
        {/* Left Section: Navigation & Toggles */}
        <div className="flex items-center gap-2">
          <Button
            size="icon"
            variant="ghost"
            className="hidden lg:flex"
            onClick={() => { toggle("left"); }}
          >
            <SidebarSimpleIcon size={18} />
          </Button>

          <div className="flex items-center gap-2 lg:hidden">
            <Button asChild size="icon" variant="ghost">
              <Link to="/dashboard/resumes">
                <ArrowLeftIcon size={18} />
              </Link>
            </Button>
          </div>

          <div className="hidden h-6 w-px bg-border/50 lg:block" />

          <Button asChild variant="ghost" size="sm" className="hidden gap-2 lg:flex">
            <Link to="/dashboard/resumes">
              <HouseSimpleIcon size={16} />
              <span className="text-sm font-medium">{t`Home`}</span>
            </Link>
          </Button>
        </div>

        {/* Center Section: Title */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="flex flex-col items-center justify-center">
            <h1 className="max-w-[200px] truncate text-sm font-semibold lg:max-w-md">
              {title}
            </h1>
          </div>
        </div>

        {/* Right Section: Actions & Toggles */}
        <div className="flex items-center gap-2">
          <Button
            size="icon"
            variant="ghost"
            className="hidden lg:flex"
            onClick={() => { toggle("right"); }}
          >
            <SidebarSimpleIcon size={18} className="-scale-x-100" />
          </Button>
        </div>
      </div>
    </motion.header>
  );
};
